import { styled } from "@styles";
import { Row, Col } from "react-bootstrap";

export const Wrapper = styled(Row)`
  border-left: 1rem solid #eee;
  border-right: 1rem solid #eee;
  border-bottom: 1rem solid #eee;
  display: ${props => props.ismobile == 'true' ? 'table;' : 'flex;'}
  padding: 1rem 0;
`;

export const PendingReviewCol = styled(Col)`
  display: table-cell;
  vertical-align: middle;
  width: auto;
`;

export const PendingReviewBrand = styled.p``;

export const PendingReviewProductName = styled.p`
  margin: 0;
`;